import { render, staticRenderFns } from "./JobDetailsPreview.vue?vue&type=template&id=3553641e"
import script from "./JobDetailsPreview.vue?vue&type=script&lang=js"
export * from "./JobDetailsPreview.vue?vue&type=script&lang=js"
import style0 from "./JobDetailsPreview.vue?vue&type=style&index=0&id=3553641e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports